<template>
  <div style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Cторонние отзывы:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat  v-if="!isOnlyRead()">
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{findNameObj('candidateCase',props.item.candidateCase)}}</td>
                <td class="justify-center">{{findNameObj('person',props.item.person)}}</td>
                <td class="justify-center"> <a v-if="props.item.review !== null " :href="props.item.review" target="_blank" rel="noopener noreferrer">Ссылка на файл</a></td>
                <td class="justify-center " v-bind="selected"  v-if="!isOnlyRead()">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Review @addItem="addItem"
              @ended="closedForm"
              @refreshItem="refreshItem"
              v-bind="selected"
              v-bind:candidateCase="this.candidateCase"
              v-bind:disable=disableCandidateCase
              v-if="opened_form"
      >
      </Review>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить Отзыв?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </div>
</template>


<script>
  import Review from "../forms/Review_person"
  import urls from "../../../../../modules/petition/urls"
  import UserDataMixin from '../../../../../mixins/UserDataMixin'
  import {isOnlyReadPermission, makeGetRequest} from "../../../../../helper";

  export default {
    name: "ListReview_person",
    components: {Review},
    mixins: [UserDataMixin],
    props: [
      "candidateCase", "disable",
    ],
    data: function () {
      return {
        URL_LIST: urls.getUrl('admin|case|models|review_person-list', 'list'),
        URL_DELETE: urls.getUrl('admin|case|models|review_person-detail', 'destroy'),

        selectors:{
          candidateCase: [],
          person: [],
          organization: [],
        },
        disableCandidateCase: this.disable || false,
        total: 0,
        items: [],
        loading: true,
        pagination: {},
        headers: [
          {
            text: 'Дело', sortable: false, align: 'justify-center',
          },
          {
            text: 'ФИО', sortable: false, align: 'justify-center',
          },

          {
            text: 'Документ', sortable: false, align: 'justify-center',
          },
          {
            text: 'Действия',
            align: 'justify-center',
            sortable: false,
          },
        ],

      }
    },
    watch: {
      pagination: {
        handler () {
          this.getItems()
        },
        deep: true
      }
    },
    methods: {
      isOnlyRead(){
        return isOnlyReadPermission()
      },
      findNameObj(edit,id){
        let obj = this.selectors[edit].find(item => item.value === id);
        if (obj !== undefined) {
          return obj.text
        }else{
          return ""
        }
      },
      addItem(){
        this.closedForm()
        this.getItems();
      },
      load: function (app, url,field) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[field].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url,field);
          });
      },
      getItems () {
        this.loading = true

        let url =  new URL(process.env.VUE_APP_API_HOST +"council/admin/case/models/review_person/")

        let params = {};

        if(this.pagination.page !== undefined) {
          params.page = this.pagination.page;
          params.page_size = this.pagination.rowsPerPage;
        }
        else{
          params.page = "1";
          params.page_size = "10";
        }
        if(this.candidateCase){
          params.candidateCase=this.candidateCase
          this.disableCandidateCase = true
        }
        url.search = new URLSearchParams(params).toString();
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }) .then(json => {
          this.items = json.results
          this.total = json.count
          this.loading = false
        })
      },
    },
    created() {
      this.getItems();
      // let url = urls.getUrl('admin|core|selectors|organization', 'get')
      // this.load(this, url,'organization')

      let url = urls.getUrl('admin|core|selectors|person', 'get')
      this.load(this, url,'person')

      url = urls.getUrl('admin|case|selectors|candidate_case', 'get')
      this.load(this, url,'candidateCase')
    },
  }


</script>
<style scoped>

</style>
